import { render, staticRenderFns } from "./VueBootstrap4Table.vue?vue&type=template&id=d9139644&scoped=true&"
import script from "./VueBootstrap4Table.vue?vue&type=script&lang=js&"
export * from "./VueBootstrap4Table.vue?vue&type=script&lang=js&"
import style0 from "./VueBootstrap4Table.vue?vue&type=style&index=0&id=d9139644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9139644",
  null
  
)

export default component.exports